/**
 * Lista branż dla BusinessWizardV2 — synchronizowana z BUSINESS_CATEGORIES (seo_meta.py).
 * Slug → { name, group } (po polsku, posortowane alfabetycznie wewnątrz grup).
 * Frontend potrzebuje slugów do zapisu w `industry`, by działały katalogi.
 */
export const BUSINESS_INDUSTRIES = [
  // Uroda i pielęgnacja
  { slug: 'fryzjer', name: 'Fryzjer', group: 'Uroda i pielęgnacja' },
  { slug: 'kosmetyczka', name: 'Kosmetyczka', group: 'Uroda i pielęgnacja' },
  { slug: 'masaz', name: 'Salon masażu', group: 'Uroda i pielęgnacja' },
  { slug: 'medycyna-estetyczna', name: 'Medycyna estetyczna', group: 'Uroda i pielęgnacja' },
  { slug: 'tatuazysta', name: 'Tatuażysta', group: 'Uroda i pielęgnacja' },

  // Zdrowie
  { slug: 'dentysta', name: 'Dentysta', group: 'Zdrowie' },
  { slug: 'fizjoterapeuta', name: 'Fizjoterapeuta', group: 'Zdrowie' },
  { slug: 'psycholog', name: 'Psycholog', group: 'Zdrowie' },
  { slug: 'dietetyk', name: 'Dietetyk', group: 'Zdrowie' },
  { slug: 'weterynarz', name: 'Weterynarz', group: 'Zdrowie' },
  { slug: 'apteka', name: 'Apteka', group: 'Zdrowie' },

  // Dom i remonty
  { slug: 'hydraulik', name: 'Hydraulik', group: 'Dom i remonty' },
  { slug: 'elektryk', name: 'Elektryk', group: 'Dom i remonty' },
  { slug: 'budowlaniec', name: 'Firma budowlana', group: 'Dom i remonty' },
  { slug: 'malarz', name: 'Malarz', group: 'Dom i remonty' },
  { slug: 'stolarstwo', name: 'Stolarz', group: 'Dom i remonty' },
  { slug: 'slusarz', name: 'Ślusarz', group: 'Dom i remonty' },
  { slug: 'sprzatanie', name: 'Firma sprzątająca', group: 'Dom i remonty' },
  { slug: 'klimatyzacja', name: 'Klimatyzacja', group: 'Dom i remonty' },
  { slug: 'fotowoltaika', name: 'Fotowoltaika', group: 'Dom i remonty' },
  { slug: 'okna-drzwi', name: 'Okna i drzwi', group: 'Dom i remonty' },
  { slug: 'ogrodzenia', name: 'Ogrodzenia', group: 'Dom i remonty' },
  { slug: 'brukarstwo', name: 'Brukarz', group: 'Dom i remonty' },
  { slug: 'ogrodnik', name: 'Ogrodnik', group: 'Dom i remonty' },

  // Moto
  { slug: 'mechanik', name: 'Mechanik samochodowy', group: 'Moto' },
  { slug: 'blacharstwo', name: 'Blacharstwo / lakiernictwo', group: 'Moto' },
  { slug: 'wulkanizacja', name: 'Wulkanizacja', group: 'Moto' },
  { slug: 'pomoc-drogowa', name: 'Pomoc drogowa', group: 'Moto' },
  { slug: 'wypozyczalnia-aut', name: 'Wypożyczalnia aut', group: 'Moto' },
  { slug: 'szkola-jazdy', name: 'Szkoła jazdy', group: 'Moto' },
  { slug: 'taxi', name: 'Taxi', group: 'Moto' },

  // Usługi profesjonalne
  { slug: 'prawnik', name: 'Prawnik / Adwokat', group: 'Usługi profesjonalne' },
  { slug: 'notariusz', name: 'Notariusz', group: 'Usługi profesjonalne' },
  { slug: 'ksiegowa', name: 'Księgowa / Biuro rachunkowe', group: 'Usługi profesjonalne' },
  { slug: 'tlumacz', name: 'Tłumacz', group: 'Usługi profesjonalne' },
  { slug: 'architekt', name: 'Architekt', group: 'Usługi profesjonalne' },
  { slug: 'geodeta', name: 'Geodeta', group: 'Usługi profesjonalne' },
  { slug: 'nieruchomosci', name: 'Nieruchomości', group: 'Usługi profesjonalne' },
  { slug: 'ubezpieczenia', name: 'Ubezpieczenia', group: 'Usługi profesjonalne' },
  { slug: 'detektyw', name: 'Detektyw', group: 'Usługi profesjonalne' },
  { slug: 'reklama', name: 'Agencja reklamowa', group: 'Usługi profesjonalne' },

  // Edukacja i sport
  { slug: 'przedszkole', name: 'Przedszkole / Żłobek', group: 'Edukacja i sport' },
  { slug: 'szkola-jezykowa', name: 'Szkoła językowa', group: 'Edukacja i sport' },
  { slug: 'trener-personalny', name: 'Trener personalny', group: 'Edukacja i sport' },
  { slug: 'silownia', name: 'Siłownia / Klub fitness', group: 'Edukacja i sport' },

  // Gastronomia i eventy
  { slug: 'restauracja', name: 'Restauracja', group: 'Gastronomia i eventy' },
  { slug: 'cukiernia', name: 'Cukiernia / Piekarnia', group: 'Gastronomia i eventy' },
  { slug: 'catering', name: 'Catering', group: 'Gastronomia i eventy' },
  { slug: 'sala-weselna', name: 'Sala weselna', group: 'Gastronomia i eventy' },
  { slug: 'dj', name: 'DJ / Wodzirej', group: 'Gastronomia i eventy' },
  { slug: 'fotograf', name: 'Fotograf', group: 'Gastronomia i eventy' },
  { slug: 'wideofilmowanie', name: 'Wideofilmowanie', group: 'Gastronomia i eventy' },
  { slug: 'kwiaciarnia', name: 'Kwiaciarnia', group: 'Gastronomia i eventy' },

  // Inne
  { slug: 'krawcowa', name: 'Krawcowa', group: 'Inne' },
  { slug: 'pralnia', name: 'Pralnia', group: 'Inne' },
  { slug: 'serwis-komputerowy', name: 'Serwis komputerowy', group: 'Inne' },
  { slug: 'drukarnia', name: 'Drukarnia', group: 'Inne' },
  { slug: 'alarm', name: 'Alarmy i monitoring', group: 'Inne' },
  { slug: 'przeprowadzki', name: 'Przeprowadzki', group: 'Inne' },
  { slug: 'opieka-seniorzy', name: 'Opieka nad seniorami', group: 'Inne' },
  { slug: 'uslugi-pogrzebowe', name: 'Usługi pogrzebowe', group: 'Inne' },
  { slug: 'dekoracja-wnetrz', name: 'Dekoracja wnętrz', group: 'Inne' },
];

export const INDUSTRY_GROUPS = [
  'Uroda i pielęgnacja',
  'Zdrowie',
  'Dom i remonty',
  'Moto',
  'Usługi profesjonalne',
  'Edukacja i sport',
  'Gastronomia i eventy',
  'Inne',
];

export function industryName(slug) {
  return BUSINESS_INDUSTRIES.find((i) => i.slug === slug)?.name || slug || '';
}
